export default __webpack_public_path__ + "static/media/us-hwy.43324df5.svg";